import React, { useState, useEffect } from 'react';
import ScreenHeading from '../../utilities/ScreenHeading/ScreenHeading';
import ScrollService from '../../utilities/ScrollService';
import Animations from '../../utilities/Animations';
import './Resume.css';

const Resume = (props) => {
	/* STATES */
	const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
	const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

	let fadeInScreenHandler = (screen) => {
		if (screen.fadeInScreen !== props.id) return;

		Animations.animations.fadeInScreen(props.id);
	};
	const fadeInSubscription =
		ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

	/* REUSABLE MINOR COMPONENTS */
	const ResumeHeading = (props) => {
		return (
			<div className='resume-heading'>
				<div className='resume-main-heading'>
					<div className='heading-bullet'></div>
					<span>{props.heading ? props.heading : ''}</span>
					{props.fromDate && props.toDate ? (
						<div className='heading-date'>
							{props.fromDate + '-' + props.toDate}
						</div>
					) : props.github && props.demo ? (
						<div className='heading-date-container'>
							<div className='heading-date'>
								<a href={props.github} target='_blank' rel='noreferrer'>
									Github
								</a>
							</div>
							<div className='heading-date'>
								<a href={props.demo} target='_blank' rel='noreferrer'>
									Demo
								</a>
							</div>
						</div>
					) : (
						<div></div>
					)}
				</div>
				<div className='resume-sub-heading'>
					<span>{props.subHeading ? props.subHeading : ''}</span>
				</div>
				<div className='resume-heading-description'>
					<span>{props.description ? props.description : ''}</span>
				</div>
			</div>
		);
	};

	/* STATIC RESUME DATA FOR THE LABELS*/
	const resumeBullets = [
		{ label: 'Education', logoSrc: 'education.svg' },
		{ label: 'Work History', logoSrc: 'work-history.svg' },
		{ label: 'Programming Skills', logoSrc: 'programming-skills.svg' },
		{ label: 'Projects', logoSrc: 'projects.svg' },
		{ label: 'Interests', logoSrc: 'interests.svg' }
	];

	//here we have
	const programmingSkillsDetails = [
		{ skill: 'JavaScript', ratingPercentage: 95 },
		{ skill: 'React JS', ratingPercentage: 85 },
		{ skill: 'Vue JS', ratingPercentage: 70 },
		{ skill: 'Express JS', ratingPercentage: 79 },
		{ skill: 'Node JS', ratingPercentage: 79 },
		{ skill: 'Mongo Db', ratingPercentage: 70 },
		{ skill: 'GRAPHQL', ratingPercentage: 70 },
		{ skill: 'HTML', ratingPercentage: 90 },
		{ skill: 'CSS', ratingPercentage: 90 }
	];

	const projectsDetails = [
		{
			title: 'Cryptocurrency Price & News Tracker',
			duration: {
				github: 'https://github.com/duckhang2210/coinburning',
				demo: 'https://coinburning.netlify.app/'
			},
			description: 'An App that get updates on Price and News on all Crypto',
			subHeading:
				'Technologies Used: React JS, Sass, Redux-Toolkit, Coin Ranking & Bing News Search APIs'
		},
		{
			title: 'Searching Web Application',
			duration: {
				github: 'https://github.com/duckhang2210/burning-search',
				demo: 'https://burning-search.netlify.app/'
			},
			description:
				'An web app with the ability to search for up-to-date results, news, images, and videos',
			subHeading: 'Technologies Used:  React, Tailwind, Google Search API'
		}
	];

	const resumeDetails = [
		<div className='resume-screen-container' key='education'>
			<ResumeHeading
				heading={'UT Austin Coding Bootcamp'}
				subHeading={'6 months Full Stack coding bootcamp'}
				fromDate={'June 2019'}
				toDate={'December 2019'}
			/>
			<ResumeHeading
				heading={'University of Technology, Viet Nam'}
				subHeading={'BACHELOR OF SCIENCE INFORMATION TECHNOLOGY'}
				fromDate={'2012'}
				toDate={'2016'}
			/>
		</div>,

		/* WORK EXPERIENCE */
		<div className='resume-screen-container' key='work-experience'>
			<div className='experience-container'>
				<ResumeHeading
					heading={'Asset Living'}
					subHeading={'FULL STACK DEVELOPER'}
					fromDate={'January 2020'}
					toDate={'October 2021'}
				/>
				<div className='experience-description'>
					<span className='resume-description-text'>
						Worked as MERN stack web and also on Webflow, Drupal.
					</span>
				</div>
				<div className='experience-description'>
					<span className='resume-description-text'>
						- Manage website development projects from initial design through
						completion, optimizing all cross-browser and multi-platform
						compatibility.
					</span>
					<br />
					<span className='resume-description-text'>
						- Work closely with designers, PM and clients to meet project
						requirements, goals, and desired functionality.
					</span>
					<br />
					<span className='resume-description-text'>
						- Develop and integrate customized themes into Webflow, React web
						applications.
					</span>
					<br />
					<span className='resume-description-text'>
						- Conduct training for clients on handling website content
						management systems.
					</span>
					<br />
				</div>
			</div>
		</div>,

		/* PROGRAMMING SKILLS */
		<div
			className='resume-screen-container programming-skills-container'
			key='programming-skills'
		>
			{programmingSkillsDetails.map((skill, index) => (
				<div className='skill-parent' key={index}>
					<div className='heading-bullet'></div>
					<span>{skill.skill}</span>
					<div className='skill-percentage'>
						<div
							style={{ width: skill.ratingPercentage + '%' }}
							className='active-percentage-bar'
						></div>
					</div>
				</div>
			))}
		</div>,

		/* PROJECTS */
		<div className='resume-screen-container' key='projects'>
			{projectsDetails.map((projectsDetails, index) => (
				<ResumeHeading
					key={index}
					heading={projectsDetails.title}
					subHeading={projectsDetails.subHeading}
					description={projectsDetails.description}
					github={projectsDetails.duration.github}
					demo={projectsDetails.duration.demo}
				/>
			))}
		</div>,

		/* Interests */
		<div className='resume-screen-container' key='interests'>
			<ResumeHeading
				heading='MMA'
				description='Apart from being a tech enthusiast and a code writer, I also love the martial arts and training to improve my health .'
			/>
			<ResumeHeading
				heading='Music'
				description="Listening to soothing music is something i can never compromise with, skimming through Spotify's pop songs charts is at times the best stress reliever that i can get my hands on."
			/>
			<ResumeHeading
				heading='Competitive Gaming'
				description='I like to challenge my reflexes a lot while competing in soccer games, pushing the rank and having interactive gaming sessions excites me the most.'
			/>
		</div>
	];

	const handleCarousal = (index) => {
		let offsetHeight = 360;

		let newCarousalOffset = {
			style: { transform: 'translateY(' + index * offsetHeight * -1 + 'px)' }
		};

		setCarousalOffsetStyle(newCarousalOffset);
		setSelectedBulletIndex(index);
	};

	const getBullets = () => {
		return resumeBullets.map((bullet, index) => (
			<div
				onClick={() => handleCarousal(index)}
				className={
					index === selectedBulletIndex ? 'bullet selected-bullet' : 'bullet'
				}
				key={index}
			>
				<img
					className='bullet-logo'
					src={require(`../../assets/Resume/${bullet.logoSrc}`).default}
					alt='B'
				/>
				<span className='bullet-label'>{bullet.label}</span>
			</div>
		));
	};

	const getResumeScreens = () => {
		return (
			<div
				style={carousalOffsetStyle.style}
				className='resume-details-carousal'
			>
				{resumeDetails.map((ResumeDetail) => ResumeDetail)}
			</div>
		);
	};

	useEffect(() => {
		return () => {
			/* UNSUBSCRIBE THE SUBSCRIPTIONS */
			fadeInSubscription.unsubscribe();
		};
	}, [fadeInSubscription]);

	return (
		<div
			className='resume-container screen-container fade-in'
			id={props.id || ''}
		>
			<div className='resume-content'>
				<ScreenHeading title={'Resume'} subHeading={'My formal Bio Details'} />
				<div className='resume-card'>
					<div className='resume-bullets'>
						<div className='bullet-container'>
							<div className='bullet-icons'></div>
							<div className='bullets'>{getBullets()}</div>
						</div>
					</div>

					<div className='resume-bullet-details'>{getResumeScreens()}</div>
				</div>
			</div>
		</div>
	);
};

export default Resume;
